import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { FaTrash } from "react-icons/fa";
import es_ES from "rsuite/locales/es_ES";
import {
  Calendar,
  HStack,
  Button,
  Text,
  Modal,
  Input,
  SelectPicker,
  DatePicker,
  NumberInput,
  CustomProvider,
  Panel,
  IconButton,
  Dropdown,
  Popover,
  Whisper,
} from "rsuite";

import {
  getCitas,
  getHorarios,
  getPaciente,
  getPacienteXNombre,
  saveCancelCita,
  saveUpdateCita,
  getTelefonoXID,
  getListaPacientes,
  getDatosAgendaCita,
  getListDetallesProgram,
} from "./Services/ConsultasServices";
import { getPermiso } from "./Services/Permisos";
import PeoplesIcon from "@rsuite/icons/Peoples";
import { FaBackward, FaSave } from "react-icons/fa";
import moment from "moment/moment";
import { LayoutHome } from "./LayoutHome";
import { Card, Col, Row, notification } from "antd";
import { PlusCircleIcon } from "lucide-react";
import MoreIcon from "@rsuite/icons/More";
import { esParOImpar } from "../Utils";

const gridStyle = {
  width: "20%",
  textAlign: "left",
  fontSize: "10px",
};

export const Citas = () => {
  const validaSession = JSON.parse(localStorage.getItem("auth"));
  if (validaSession === null) {
    window.location = `/#/App`;
  }
  const [idNegocio] = useState(JSON.parse(localStorage.getItem("auth")).id);
  const [permiso, setPermiso] = useState("");
  const [negocio] = useState(
    JSON.parse(localStorage.getItem("auth")).consultorio,
  );
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768); // Initial check
  const idUser = JSON.parse(localStorage.getItem("auth")).idUser;
  const [dataPaciente, setDataPaciente] = useState([]);
  const [idturno, setIdTurno] = useState("");
  const [turno, setTurno] = useState("");
  const [lista, setLista] = useState([]);
  const [fechaCita, setFechaCita] = useState("");
  const [motivoCancel, setMotivoCancel] = useState("");
  const [dataCancel, setDataCancel] = useState("");
  const [open, setOpen] = useState(false);
  const handleClose = () => {
    setOpen(false);
    setIdPacSel("0");
  };
  const [btnCancel, setBtnCancel] = useState(false);
  const [fecha, setFecha] = useState("");
  const [idPaciente, setIdPaciente] = useState(0);
  const [paciente, setPaciente] = useState("");
  const [telefono, setTelefono] = useState("");
  const [openHor, setOpenHor] = useState(false);
  const [dataEdit, setDataEdit] = useState("");
  const [disableBtn, setDisableBtn] = useState(true);
  const handleCloseHorario = () => {
    setOpenHor(false);
    setIdPacSel("0");
  };
  const [dataHorarios, setDataHorarios] = useState([]);
  const [disableHors, setDisableHors] = useState(true);
  const [fechaHorario, setFechaHorario] = useState("");
  const [horario, setHorario] = useState("");
  const [nuevaCita, setNuevaCita] = useState(false);
  const [horNvaCita, setHorNvaCita] = useState("");
  const [message, setMessage] = useState("");
  const [disabledBtmMsj, setDisabledBtnMsj] = useState(true);
  const [espacio, setEspacio] = useState(0);
  const [currentTime] = useState(new Date());
  const [nuevaFecha, setNuevaFecha] = useState("");
  const [horaIni, setHoraIni] = useState("");
  const [tipoHorario, setTipoHorario] = useState("");
  const [nuevoPac, setNuevoPac] = useState(false);
  const [showListaPac, setSowListaPac] = useState(true);
  const [listaPacientes, setListaPacientes] = useState([]);
  const [showLista, setShowLista] = useState(false);
  const [idServicio, setIdServicio] = useState("1");
  const [idPacSel, setIdPacSel] = useState("");
  const [horarioDet, setHorarioDet] = useState("");
  const [dataDetalles, setDataDetalles] = useState([]);
  const [loadingCita, setLoadingCita] = useState(false);

  const initialized = useRef(false);
  const navigate = useNavigate();
  const [api, contextHolder] = notification.useNotification();

  const errorNotificaction = (title, msj) => {
    api.error({
      title: title,
      description: msj,
      duration: 5,
      styles: { root: { backgroundColor: "#FFE4E0" } },
      showProgress: true,
    });
  };

  const successNotification = (title, msj) => {
    api.success({
      title: title,
      description: msj,
      duration: 5,
      styles: { root: { backgroundColor: "#ECFFE0" } },
      showProgress: true,
    });
  };

  const fetchHorarios = async (fecha) => {
    await getHorarios(idNegocio, fecha).then((nxt) => {
      setFechaHorario(fecha);
      setDataHorarios(nxt);
    });
  };

  const fetchPaciente = async (valueTel) => {
    setTelefono(valueTel);
    const response = await getPaciente(idNegocio, valueTel);
    if (response.status === 204) {
      setNuevoPac(true);
      setPaciente("");
    } else {
      if (!response.nombre) {
        setNuevoPac(true);
      } else {
        setPaciente(response.nombre);
      }
    }
  };

  const getPacientePorNombre = async (nombre) => {
    const response = await getPacienteXNombre(idNegocio);
    setDataPaciente(response);
  };

  const handleChangeTelefono = async (value) => {
    setTelefono(value);
  };

  const fetchCitas = async (date) => {
    await getCitas(idNegocio, idServicio, date, "Todas")
      .then((nxt) => {
        setLista(nxt.lstCitas);
        const citas = nxt.lstCitas;
        return citas.length;
      })
      .catch((error) => {
        if (error.status === 401) {
          errorNotificaction(
            "Error de inicio",
            "Debe iniciar sesión, antes de continuar...",
          );
          setTimeout(() => {
            window.location = `/#/App`;
          }, 1200);
        } else {
          errorNotificaction(error.name, error.message);
        }
      });
  };

  const renderMenu = ({ onClose, left, top, className, props }, ref) => {
    const handleSelect = (eventKey) => {
      console.log(eventKey);
      if (eventKey === 1) {
        handleEditModal({
          idPac: props.idPac,
          fecha: props.fecha,
          hora: props.hora,
          opcion: "Reprog",
        });
      }
      if (eventKey === 2) {
        openModalCancel({
          idPac: props.idPac,
          fecha: props.fecha,
          hora: props.hora,
        });
      }
    };
    return (
      <Popover ref={ref} className={className} style={{ left, top }} full>
        <Dropdown.Menu onSelect={handleSelect}>
          <Dropdown.Item eventKey={1}>Editar cita</Dropdown.Item>
          <Dropdown.Item eventKey={2}>Cancelar</Dropdown.Item>
        </Dropdown.Menu>
      </Popover>
    );
  };

  const cancelarCita = async () => {
    if (permiso === "L") {
      errorNotificaction(
        "Permiso Lectura",
        "El usuario no cuenta con permiso para editar o cancelar.",
      );
      return;
    }

    const datos = {
      id: idNegocio,
      idServicio: idServicio,
      espacio: espacio,
      fecha: fechaCita,
      idUser: idUser,
      motivo: motivoCancel,
    };

    if (!motivoCancel) {
      errorNotificaction("Motivo", "Debes escribir un motivo antes de guardar");
      return;
    }

    const res = await saveCancelCita(datos);

    if (res.data === -1) {
      errorNotificaction(
        "Cita",
        "No se ha cancelado la cita, porque ya se cuenta con una consulta.",
      );
      return;
    }
    if (res.data === 0) {
      errorNotificaction(
        "Cita",
        "No se ha cancelado la cita, intente nuevamente.",
      );
      return;
    } else {
      successNotification("Cita", "La cita se ha cancelado de forma correcta.");
      setOpen(false);
      const utcDate = moment(nuevaFecha).format("YYYY-MM-DD");
      setShowLista(false);
      fetchCitas(utcDate);
    }
  };

  const save = async () => {
    if (permiso === "L") {
      errorNotificaction(
        "Permiso Lectura",
        "El usuario no cuenta con permiso para editar.",
      );
      return;
    }

    if (telefono.length < 10) {
      errorNotificaction("Telefono", "Debes colocar un numero teléfóno.");
      return;
    }

    if (idPaciente === "0") {
      errorNotificaction(
        "Paciente",
        "Selecciona un paciente antes de continuar.",
      );
      return;
    }

    if (tipoHorario === "horarioLibre" && !horaIni) {
      errorNotificaction("Horario", "El horario no puede estar vacio");
      return;
    }

    if (fechaCita) {
      setFechaHorario(fecha);
      setFechaCita(fecha);
      setNuevaFecha(fecha);
    }

    setLoadingCita(true);
    const dataCita = {
      id: idNegocio,
      idServicio: idServicio,
      idPaciente: idPaciente,
      espacio: espacio,
      fechaAnterior:
        tipoHorario === "horarioLibre"
          ? nuevaFecha
          : nuevaCita
            ? nuevaFecha
            : fechaCita,
      fecha:
        tipoHorario === "horarioLibre"
          ? nuevaFecha
          : nuevaCita
            ? nuevaFecha
            : fechaHorario.substring(0, 10),
      hora: tipoHorario === "horarioLibre" ? horaIni : horario,
      nombre: paciente,
      telefono: telefono,
      correo: "",
      domicilio: "",
      edoMun: "",
      descripCita: "",
      nuevaCita: nuevaCita,
      tipoHorario: tipoHorario,
    };

    await saveUpdateCita(dataCita)
      .then(async (res) => {
        if (res.data === -1) {
          errorNotificaction(
            "Horario",
            "El horario no se encuentra disponible.",
          );
          setLoadingCita(false);
          return;
        }
        if (res.data === -2) {
          errorNotificaction(
            "Cita",
            "La cita no puede ser re-programada ya se ha realizado.",
          );
          setLoadingCita(false);
          return;
        }

        if (res.data === -3) {
          errorNotificaction(
            "Cita",
            "La cita no puede ser programada el horario esta ocupado.",
          );
          setLoadingCita(false);
          return;
        }

        successNotification("Cita", "Se actualizo la cita de forma correcta");

        const utcDate = moment(nuevaFecha).format("YYYY-MM-DD");
        await fetchCitas(utcDate).then(async (res) => {
          await mostrarDetalles({
            fecha: utcDate,
            horario: tipoHorario === "horarioLibre" ? horaIni : horario,
          }).then((res) => {
            setDisableBtn(true);
            setDisabledBtnMsj(false);
            setShowLista(false);
            setOpenHor(false);
          });
        });
      })
      .catch((err) => {
        setLoadingCita(false);
        errorNotificaction(err.name, err.message);
      });
  };

  const sendMessage = () => {
    var anchor = document.createElement("a");
    anchor.href = `https://api.whatsapp.com/send?phone=${telefono}&text=${message}`;
    anchor.target = "_blank";
    anchor.click();
    setOpenHor(false);
  };

  const handleSelect = (date) => {
    setIdPacSel("0");
    const _date = moment(date).format("DD/MMM/YYYY");
    const utcDate = moment(date).format("YYYY-MM-DD");
    setFecha(_date);
    setShowLista(false);
    setDataDetalles([]);
    fetchCitas(utcDate);
    setHorarioDet("");
  };

  const maskTime = (value) => {
    setHoraIni(
      value
        .replace(/\D/g, "")
        .replace(/(\d{2})(\d)/, "$1:$2")
        .replace(/(\d{2})(\d)/, "$1:$2"),
    );
  };

  const handleEditModal = async (props) => {
    await getDatosAgendaCita(
      idNegocio,
      idServicio,
      props.idPac,
      props.fecha,
      props.hora,
    )
      .then((res) => {
        setIdPaciente(props.idPac);
        setDisabledBtnMsj(true);
        setMessage("");
        setTipoHorario(props.opcion);
        setFechaCita(`${res.fecha} ${res.hora}`);
        setDataEdit(
          `${res.nombre} / (${res.espacio}) ${res.fecha} ${res.hora}`,
        );
        setFecha(res.fecha);
        setEspacio(res.espacio);
        setTelefono(res.telefono);
        setPaciente(res.nombre);
        setNuevaCita(false);
        setNuevoPac(false);
        setLoadingCita(false);
        setOpenHor(true);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleChangeFec = (e) => {
    if (e != null) {
      var fecha = new Date(e).toISOString();
      setDisableHors(false);
      setNuevaFecha(e);
      fetchHorarios(fecha);
    } else {
      setDataHorarios([]);
    }
  };

  const handleDisabledDate = (date) => {
    return date.getTime() < moment().startOf("day").valueOf();
  };

  const handleHorario = (e) => {
    if (e === null) {
      setHorario("");
      setDisableBtn(true);
      setMessage("");
    } else {
      setHorario(e);
      setDisableBtn(false);
      const _hor = e.substring(0, 5);
      const _fec = moment(fechaHorario).format("DD/MM/YYYY");
      setMessage(
        `Buen día, le escribimos del ${negocio.NomConsultorio}. Confirmando su cambio de Fecha y hora de la cita para el: ${_fec} en el horario de las: ${_hor}`,
      );
    }
  };

  const handleNewCita = async (props) => {
    if (props.disponible === 0) {
      return;
    }
    setListaPacientes([]);
    setIdPaciente("0");
    var fec = moment(fecha).format("DD/MM/YYYY");
    setDataEdit(`${fec}`);
    setHorario(props.hora);
    setHorNvaCita(props.hora);
    setTelefono("");
    setPaciente("");
    setMessage("");
    setHoraIni("");
    setNuevaCita(true);
    setTipoHorario(props.opcion);
    var nuevaFec = moment(props.fecha).format("YYYY-MM-DD");
    setNuevaFecha(nuevaFec);
    setNuevaCita(props.nuevaCita);
    getPacientePorNombre();
    setNuevoPac(false);
    setLoadingCita(false);
    setOpenHor(true);

    await getListaPacientes(idNegocio).then((res) => {
      setListaPacientes(res);
    });
  };

  const handleNuevoNombre = async (e) => {
    if (!e) {
      setDisableBtn(true);
      setPaciente("");
    } else {
      setDisableBtn(false);
      setPaciente(e);
    }
  };

  const mostrarDetalles = async (props) => {
    const _fec = moment(props.fecha).format("YYYY-MM-DD");

    await getListDetallesProgram(
      idNegocio,
      idServicio,
      _fec,
      props.horario,
    ).then((res) => {
      setShowLista(true);
      setHorarioDet(props.horario);
      var lista = [];
      setIdTurno(res.idTurno);
      setTurno(res.turno);

      res.lista.forEach((itm) => {
        lista.push({
          id: itm.id,
          no: itm.no,
          fecha: itm.fecha,
          hora: itm.hora,
          icon: <PeoplesIcon />,
          value: itm.value,
          estatus: itm.estatus,
        });
      });
      setDataDetalles(lista);
    });
  };

  const hanldeNombrePaciente = async (e) => {
    if (!e) {
      setTelefono("");
      return;
    }
    if (e === "0") {
      setSowListaPac(false);
      setNuevaCita(true);
      setNuevoPac(true);
      return;
    }

    setIdPaciente(e);

    const res = await getTelefonoXID(idNegocio, e);
    if (!res) {
      setTelefono("");
    }
    if (res.telefono === undefined) {
      return;
    }

    setTelefono(res.telefono);
  };

  const handleShowModalPac = (e, props) => {
    setIdPacSel(e);
  };

  const openModalCancel = async (props) => {
    await getDatosAgendaCita(
      idNegocio,
      idServicio,
      props.idPac,
      props.fecha,
      props.hora,
    )
      .then((res) => {
        setFechaCita(`${res.fecha} ${res.hora}`);
        setDataCancel(
          `${res.nombre} / (${res.espacio}) ${res.fecha} ${res.hora}`,
        );
        setEspacio(res.espacio);
        setBtnCancel(false);
        setOpen(true);
      })
      .catch((err) => {
        console.log(err);
        setBtnCancel(true);
      });
  };

  const loadPermiso = async () => {
    await getPermiso(idNegocio, idUser, "Citas").then((res) => {
      setPermiso(res);
    });
  };

  useEffect(() => {
    let isMounted = true; // flag to track mount status
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768); // Update on resize
    };

    if (!initialized.current) {
      initialized.current = true;
      loadPermiso();
    }

    window.addEventListener("resize", handleResize);
    // Set up an interval to update the time every second

    return () => {
      window.removeEventListener("resize", handleResize); // Cleanup
      isMounted = false;
    };
  }, []); // Empty dependency array ensures this effect runs only once on mount

  return (
    <>
      <title>Citas Hemodíalisis - NefroSys</title>
      <LayoutHome
        titleItems={[
          {
            title: (
              <a href="/#/App/Home" style={{ textDecoration: "none" }}>
                Menú
              </a>
            ),
          },
          { title: "Citas (Hemodialisis)" },
        ]}
        selectedKey={"2.1"}
      >
        {contextHolder}
        <div className="row mb-3">
          <div className="col-lg-6 col-md-6 col-sm-6">
            <CustomProvider locale={es_ES}>
              <Calendar compact onSelect={handleSelect} bordered />
            </CustomProvider>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-6">
            <Text size={"lg"} weight="bold">
              Sesiones de Hemodialisis
            </Text>
            <HStack align="flex-end">
              <Text size={"lg"}>Horarios del: {fecha}</Text>
            </HStack>
            <div className="row">
              {lista.map((item, index) => (
                <div
                  className="col-lg-3 col-md-3 col-sm-3"
                  key={`divCell-${index}`}
                >
                  <Card
                    key={`encGrid-${index}`}
                    hoverable={true}
                    style={{
                      textAlign: "center",
                      backgroundColor:
                        item.idTurno === "MAT" ? "#CFF6FF" : "#F6FF99",
                    }}
                    actions={[
                      <Button
                        appearance="link"
                        startIcon={<PlusCircleIcon></PlusCircleIcon>}
                        onClick={() =>
                          handleNewCita({
                            idPac: item.idPac,
                            nombre: item.nombre,
                            fecha: item.fecha,
                            hora: item.hora,
                            telefono: item.telefono,
                            disponible: item.espacio,
                            nuevaCita: true,
                            opcion: "horarioDisp",
                          })
                        }
                      >
                        {`Lugares: ${item.espacio}`}
                      </Button>,
                    ]}
                    onClick={() =>
                      mostrarDetalles({
                        fecha: item.fecha,
                        horario: item.hora,
                      })
                    }
                  >
                    <Text size={"md"} weight="bold">
                      Horario
                    </Text>
                    <Text size={"md"} color={"blue"} weight="semibold">
                      {item.hora}
                    </Text>
                  </Card>
                </div>
              ))}
            </div>
            {/* </List> */}
          </div>
        </div>
        <div className="row">
          <div className="col">
            <Card
              title={`Turno: ${turno} - Pacientes Programados: ${fecha} - Horario: ${horarioDet}`}
            >
              {dataDetalles.map((item, index) => (
                <Card.Grid
                  id={`cardPac-${index}`}
                  style={{
                    width: "20%",
                    textAlign: "left",
                    fontSize: "10px",
                    backgroundColor: esParOImpar(index) === 1 ? "#F5F2F2" : "",
                  }}
                >
                  <Row id={`p-${index}`}>
                    <Col style={{ fontSize: "14px" }}>
                      <b>({item.no})</b> {item.value}{" "}
                      <Whisper
                        placement="autoVerticalStart"
                        trigger="click"
                        speaker={renderMenu({
                          props: {
                            idPac: item.id,
                            fecha: item.fecha,
                            hora: item.hora,
                            opcion: "Reprog",
                          },
                        })}
                      >
                        <IconButton appearance="subtle" icon={<MoreIcon />} />
                      </Whisper>
                    </Col>
                  </Row>
                  <Row>
                    <Col style={{ textAlign: "right" }}>
                      <b style={{ fontSize: "12px" }}>
                        {item.estatus === "Nuevo" ? "* Nuevo" : item.estatus}
                      </b>
                    </Col>
                  </Row>
                  <Row></Row>
                </Card.Grid>
              ))}
            </Card>
          </div>
        </div>

        {/* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> MODAL DE CANCELACIÓN <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */}
        <Modal
          open={open}
          onClose={handleClose}
          backdrop="static"
          overflow="false"
        >
          <Modal.Header>
            <Modal.Title>Cita: {dataCancel}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Panel bordered>
              <div className="row">
                <div className="col">
                  <b>Motivo</b>
                  <Input
                    as="textarea"
                    rows={4}
                    placeholder="Escriba el motivo de la cancelación de la cita."
                    onChange={(e) => setMotivoCancel(e)}
                    disabled={btnCancel}
                  />
                </div>
              </div>
            </Panel>
          </Modal.Body>
          <Modal.Footer>
            <Button
              onClick={handleClose}
              appearance="primary"
              startIcon={<FaBackward></FaBackward>}
            >
              Regresar
            </Button>
            <Button
              color="red"
              startIcon={<FaTrash></FaTrash>}
              onClick={cancelarCita}
              disabled={btnCancel}
              appearance="primary"
            >
              Cancelar
            </Button>
          </Modal.Footer>
        </Modal>

        {/* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> MODAL DE EDICION PARA HORARIO Y NUEVA CITA O RE-PROG <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */}
        <Modal
          size="lg"
          open={openHor}
          onClose={handleCloseHorario}
          backdrop="static"
          overflow="false"
        >
          <Modal.Header>
            <Modal.Title>Cita: {dataEdit}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Panel bordered>
              <div className="row mb-1">
                <div className="col-lg-8 col-md-8 col-sm-8">
                  <b>Nombre</b>
                  <span style={{ color: "red", fontSize: "12px" }}>
                    &nbsp; * Obligatorio
                  </span>
                  {nuevaCita ? (
                    <SelectPicker
                      width={"100%"}
                      data={listaPacientes}
                      value={idPaciente}
                      onChange={(e) => hanldeNombrePaciente(e)}
                      searchable
                      placeholder="Selecciona un paciente..."
                      block
                    ></SelectPicker>
                  ) : (
                    <Input readOnly value={paciente} />
                  )}
                </div>
                <div className="col-lg-4 col-md-4 col-sm-4">
                  <b>Teléfono</b>
                  <span style={{ color: "red", fontSize: "12px" }}>
                    &nbsp; * Obligatorio
                  </span>
                  <NumberInput
                    controls={false}
                    value={telefono}
                    onChange={(e) => handleChangeTelefono(e)}
                    maxLength={10}
                    min={0}
                  />
                </div>
              </div>
              <div className="row mb-3">
                <div className="col-lg-6 col-md-6 col-sm-6">
                  <b>Fecha</b>
                  {tipoHorario === "horarioDisp" ? (
                    <Input
                      readOnly
                      value={moment(nuevaFecha).format("DD/MM/YYYY")}
                    />
                  ) : tipoHorario === "Reprog" ? (
                    <CustomProvider locale={es_ES}>
                      <DatePicker
                        block
                        shouldDisableDate={handleDisabledDate}
                        onChange={(e) => handleChangeFec(e)}
                      />
                    </CustomProvider>
                  ) : (
                    <Input
                      readOnly
                      value={nuevaFecha}
                      style={{ textAlign: "center" }}
                    />
                  )}
                </div>
                <div className="col-lg-6 col-md-6 col-sm-6">
                  <b>Horario</b>
                  {tipoHorario === "horarioDisp" ? (
                    <Input
                      readOnly
                      value={horNvaCita}
                      defaultValue={horNvaCita}
                    />
                  ) : tipoHorario === "Reprog" ? (
                    <SelectPicker
                      style={{ width: "auto" }}
                      block
                      searchable={false}
                      data={dataHorarios}
                      disabled={disableHors}
                      onChange={(e) => handleHorario(e)}
                      placeholder="Selecciona un horario"
                    />
                  ) : (
                    <Input
                      placeholder="00:00"
                      maxLength={5}
                      value={horaIni}
                      onChange={(e) => maskTime(e)}
                      style={{ textAlign: "center" }}
                    />
                  )}
                </div>
              </div>
            </Panel>
          </Modal.Body>
          <Modal.Footer>
            <Button
              onClick={handleCloseHorario}
              startIcon={<FaBackward></FaBackward>}
            >
              Regresar
            </Button>
            <Button
              appearance="primary"
              loading={loadingCita}
              onClick={save}
              disabled={nuevaCita ? false : disableBtn}
              startIcon={<FaSave></FaSave>}
            >
              Guardar
            </Button>
          </Modal.Footer>
        </Modal>
      </LayoutHome>
    </>
  );
};
